/*
 * Copyright (c) 2025.  Chad and contributors.
 * All rights reserved.
 *
 * These take parameters to be able to mock them in tests.
 */

type EnvMode = 'production' | 'development' | 'staging' | 'test' | 'unknown';

function checkEnvironment(expected: EnvMode, metaEnv: { MODE?: string } = import.meta.env): boolean {
    return getEnvMode(metaEnv) === expected;
}

export function getEnvMode(metaEnv: { MODE?: string } = import.meta.env): EnvMode {
    const mode = metaEnv.MODE?.toLowerCase() as EnvMode;
    return ['production', 'development', 'staging', 'test'].includes(mode) ? mode : 'unknown';
}

export const isProduction = (metaEnv?: { MODE: string }) => checkEnvironment('production', metaEnv);
export const isDevelopment = (metaEnv?: { MODE: string }) => checkEnvironment('development', metaEnv);
export const isStaging = (metaEnv?: { MODE: string }) => checkEnvironment('staging', metaEnv);
export const isTest = (metaEnv?: { MODE: string }) => checkEnvironment('test', metaEnv);